const SvgGridSelected = () => <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 32 32">
    <path d="M2 2h6.667v6.667H2zm10.667 0h6.667v6.667h-6.667zm0 10.667h6.667v6.667h-6.667zm0 10.666h6.667V30h-6.667zM23.333 2H30v6.667h-6.667zm0 10.667H30v6.667h-6.667zm0 10.666H30V30h-6.667zM2 12.667h6.667v6.667H2zm0 10.666h6.667V30H2z" />
  </svg>;
export default SvgGridSelected;